export default __webpack_public_path__ + "static/media/logoblue.eba0e948.png";